// import slide3 from './images/jpg/slider3.jpg';

const Jpg = {
    // slide1,
}

export default Jpg;
